import React from "react";
import { Box, Link, List, ListItem, Stack } from "@mui/material";
import { isToday } from "date-fns";
import { useTranslation } from "next-i18next";
import { Typography } from "src/components-mui/base/typography/typography";
import { INewsListProps } from "src/components-mui/pages/detail/news/news-list.types";
import { useDateTimeFormatter } from "src/hooks/formatters/use-date-time-formatter";

export const NewsList = ({ items }: INewsListProps) => {
    const { t } = useTranslation("common");
    const { formatWeekDayShortWithTimeShort, formatTimeShort } = useDateTimeFormatter();
    const formatArticleTime = (time: string) => {
        const articleTime = new Date(time);
        const isTodayDate = isToday(articleTime);

        if (isTodayDate) {
            return `${t("today")}, ${formatTimeShort(articleTime)}`;
        }

        return formatWeekDayShortWithTimeShort(articleTime);
    };

    return (
        <List sx={{ p: 0 }}>
            {items.map(({ date, link }) => (
                <ListItem key={`${link.url}${date}`} disablePadding sx={{ py: 2, borderBottom: "1px solid", borderColor: "gray.200" }}>
                    <Stack direction="row" sx={{ alignItems: "center", gap: 2 }}>
                        <Box component="span" sx={{ flexShrink: 0, fontSize: "sm", width: theme => theme.spacing(6) }}>
                            {formatArticleTime(date)}
                        </Box>
                        <Link
                            href={link.url}
                            variant="unstyled"
                            underline="none"
                            sx={{
                                color: "gray.800",
                                "&:hover": { textDecoration: "underline", color: "gray.800" },
                                "&:active": { color: "gray.900" },
                            }}
                        >
                            <Typography
                                component="span"
                                sx={{
                                    fontSize: "sm",
                                    fontWeight: "bold",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                }}
                            >
                                {link.name}
                            </Typography>
                        </Link>
                    </Stack>
                </ListItem>
            ))}
        </List>
    );
};
